/**
 * The position of the FormField label (Top vs Left vs Hidden).
 */
export var FormFieldLabelPosition;
(function (FormFieldLabelPosition) {
    FormFieldLabelPosition[FormFieldLabelPosition["Top"] = 0] = "Top";
    FormFieldLabelPosition[FormFieldLabelPosition["Left"] = 1] = "Left";
    FormFieldLabelPosition[FormFieldLabelPosition["Hidden"] = 2] = "Hidden";
})(FormFieldLabelPosition || (FormFieldLabelPosition = {}));
